export const quotePreviewType = {
  xls: "xls",
  pdf: "pdf",
};
